import React, { useState, useEffect, ChangeEvent, useRef } from 'react';
import { Stack, FormControl, FormLabel, TextField, MenuItem, Autocomplete, Box, Typography, Alert, FormControlLabel, Checkbox } from '@mui/material';

const options = [
  { title: 'Sambel Goreng Kentang' },
  { title: 'Acar Nanas' },
  { title: 'Mie Goreng' },
];
const optionsBox = [
  { title: 'Tumis Bakso' },
  { title: 'Mie Goreng' },
];

const optionsKatalogB = [
  { title: 'Tumis Bakso' },
  { title: 'Mie Goreng' },
];


const paketKambing = [
  {
    
    title: 'A Ultimate Cetak ', sayur: 2, paketNasi: [
      {
        title: 'Nasi Putih', imgPath: 'images/ultimate-cetak.webp'
      },
      {
        title: 'Nasi Kebuli (+1.000/box)', imgPath: 'images/ultimate-cetak.webp'
      }

    ], minBox: 50, priceBox: 21500, priceKebuli: 2000, imgPath: 'images/ultimate-cetak.webp',
  },
  {
    title: 'A Ultimate Sebar ', sayur: 2, paketNasi: [
      {
        title: 'Nasi Putih', imgPath: 'images/ultimate-sebar.webp'
      },
      {
        title: 'Nasi Kebuli (+1.500/box)', imgPath: 'images/ultimate-sebar-kebuli.webp'
      },
    ], minBox: 50, priceBox: 25000, priceKebuli: 3000, imgPath: 'images/ultimate-sebar.webp'
  },
  {
    title: 'A Ruby Cetak ', sayur: 1, paketNasi:
      [
        {
          title: 'Nasi Putih', imgPath: 'images/ruby-cetak-baru.jpg'
        },
        {
          title: 'Nasi Kebuli (+1.000/box)', imgPath: 'images/ruby-cetak-baru.jpg'
        },
      ], minBox: 50, priceBox: 13000, priceKebuli: 2000, imgPath: 'images/ruby-cetak-baru.jpg'
  },
  {
    title: 'A Ruby Sebar ', sayur: 2, paketNasi: [
      {
        title: 'Nasi Putih', imgPath: 'images/ruby-sebar-putih-baru.jpg'
      },
      {
        title: 'Nasi Kebuli (+1.500/box)', imgPath: 'images/ruby-sebar-kebuli-baru.jpg'
      },], minBox: 50, priceBox: 17000, priceKebuli: 2500, imgPath: 'images/ruby-sebar-2.jpg'
  },
  {
    
    title: 'B Ultimate Cetak  ', sayur: 2, paketNasi: [
      {
        title: 'Nasi Putih', imgPath: 'images/ultimateB-cetak.webp'
      },
      {
        title: 'Nasi Kebuli (+1.500/box)', imgPath: 'images/ultimateB-cetak.webp'
      }

    ], minBox: 40, priceBox: 21500, priceKebuli: 2000, imgPath: 'images/ultimateB-cetak.webp',
  },
  {
    title: 'B Ultimate Sebar  ', sayur: 2, paketNasi: [
      {
        title: 'Nasi Putih', imgPath: 'images/ultimateB-sebar.webp'
      },
      {
        title: 'Nasi Kebuli (+2.000/box)', imgPath: 'images/ultimate-b-kebuli-sebar.webp'
      },
    ], minBox: 40, priceBox: 25000, priceKebuli: 3000, imgPath: 'images/ultimateB-sebar.webp'
  },

  {
    title: 'B Ruby Cetak ', sayur: 1, paketNasi:
      [
        {
          title: 'Nasi Putih', imgPath: 'images/rubyB-cetak.webp'
        },
        {
          title: 'Nasi Kebuli (+1.500/box)', imgPath: 'images/rubyB-cetak.webp'
        },
      ], minBox: 40, priceBox: 13000, priceKebuli: 2000, imgPath: 'images/rubyB-cetak.webp'
  },
  { 
    title: 'B Ruby Sebar ', sayur: 2, paketNasi: [
      {
        title: 'Nasi Putih', imgPath: 'images/rubyB-sebar.webp'
      },
      {
        title: 'Nasi Kebuli (+2.000/box)', imgPath: 'images/rubyB-sebar.webp'
      },], minBox: 40, priceBox: 17000, priceKebuli: 2500, imgPath: 'images/ruby-b-kebuli-sebar.webp'
  },
  {
    title: 'Sate A ', sayur: 2, paketNasi: [
      {
        title: 'Nasi Putih', imgPath: 'images/Sate-A.jpg'
      },
      {
        title: 'Nasi Kebuli (+1.500/box)', imgPath: 'images/sate-kebuli-sebar.webp'
      },
    ], minBox: 50, priceBox: 0, priceKebuli: 0, imgPath: 'images/Sate-A.jpg'
  },
  {
    title: 'Sate B ', sayur: 2, paketNasi: [
      {
        title: 'Nasi Putih', imgPath: 'images/Sate-B.jpg'
      },
      {
        title: 'Nasi Kebuli (+1.000/box)', imgPath: 'images/Sate-B.jpg'
      },

    ], minBox: 50, priceBox: 0, priceKebuli: 0, imgPath: 'images/Sate-B.jpg'
  },
  {
    title: 'Box Cetak ', sayur: 1, paketNasi: [
      {
        title: 'Nasi Putih', imgPath: 'images/box-cetak.png'
      },
      {
        title: 'Nasi Kebuli (+2.000/box)', imgPath: 'images/box-cetak.png'
      },

    ], minBox: 50, priceBox: 0, priceKebuli: 0, imgPath: 'images/box-cetak.png'
  },
  {
    title: 'Box Sebar ', sayur: 2, paketNasi: [
      {
        title: 'Nasi Putih', imgPath: 'images/box-sebar.png'
      },
      {
        title: 'Nasi Kebuli (+2.500/box)', imgPath: 'images/box-kebuli.png'
      },
    ], minBox: 50, priceBox: 0, priceKebuli: 0, imgPath: 'images/box-sebar.png'
  },
 
  {
    title: 'Ember Tutup ', sayur: 2, paketNasi: [
      {
        title: 'Nasi Putih', imgPath: 'images/ember-tutup.webp'
      },
      {
        title: 'Nasi Kebuli (+3.000/box)', imgPath: 'images/ember-tutup.webp'
      },
    ], minBox: 50, priceBox: 0, priceKebuli: 0, imgPath: 'images/ember-tutup.webp'
  },
  {
    title: 'Ember Buka ', sayur: 2, paketNasi: [
      {
        title: 'Nasi Putih', imgPath: 'images/ember-buka.webp'
      },
      {
        title: 'Nasi Kebuli (+3.000/box)', imgPath: 'images/ember-buka.webp'
      },
    ], minBox: 50, priceBox: 0, priceKebuli: 0, imgPath: 'images/ember-buka.webp'
  },
  {
    title: 'Ceting Tenteng ', sayur: 2, paketNasi: [
      {
        title: 'Nasi Putih', imgPath: 'images/ceting-tenteng.webp'
      },
      {
        title: 'Nasi Kebuli (+3.000/box)', imgPath: 'images/ceting-tenteng.webp'
      },
    ], minBox: 50, priceBox: 0, priceKebuli: 0, imgPath: 'images/ember-tenteng.webp'
  },
  {
    title: 'Ceting Biasa ', sayur: 2, paketNasi: [
      {
        title: 'Nasi Putih', imgPath: 'images/ceting-biasa.webp'
      },
      {
        title: 'Nasi Kebuli (+3.000/box)', imgPath: 'images/ceting-biasa.webp'
      },
    ], minBox: 50, priceBox: 0, priceKebuli: 0, imgPath: 'images/ceting-biasa.webp'
  },



];

const paketCatering = [
  { title: 'Pedia 1', minBox: 50, imgPath: '/images/pedia1.jpg', priceBox: 23900 },
  { title: 'Pedia 2', minBox: 50, imgPath: '/images/pedia2.jpg', priceBox: 29900 },
  { title: 'Pedia 3', minBox: 50, imgPath: '/images/pedia3.jpg', priceBox: 31900 },
  { title: 'Pedia 4', minBox: 50, imgPath: '/images/pedia4.jpg', priceBox: 33900 }
];


type DagingOption = {
  jumlahDaging: number;
  harga: number;
};

type PaketNasiItem = {
  title: string;
  imgPath: string;
};


const dataKambing: Record<string, DagingOption[]> = {
  Jawa: [
    { jumlahDaging: 100, harga: 2000000 },
    { jumlahDaging: 125, harga: 2200000 },
    { jumlahDaging: 150, harga: 2500000 },
    { jumlahDaging: 200, harga: 3100000 },
  ],
  Domba: [
    { jumlahDaging: 50, harga: 1550000 },
    { jumlahDaging: 80, harga: 1750000 },
    { jumlahDaging: 100, harga: 1900000 },
    { jumlahDaging: 125, harga: 2050000 },
    { jumlahDaging: 150, harga: 2400000 },
  ],
};

const kkjDenganBiayaTambahan = [
  { nama: 'Tengkleng', biaya: 1000 },
  { nama: 'Gulai', biaya: 1000 }
];

const opsiKkjLengkap = [
  { value: 'Tongseng', label: 'Tongseng' },
  { value: 'Sambal Hijau', label: 'Cabai Ijo (Best Seller)' },
  { value: 'Gulai', label: 'Gulai' },
  { value: 'Tengkleng', label: 'Tengkleng' },
];

const opsiKkjTerbatas = [
  { value: 'Tongseng', label: 'Tongseng' },
  { value: 'Sambal Hijau', label: 'Cabai Ijo (Best Seller)' },
];



const Step2Form = ({ formData, handleChange, resetForm, sisaDaging, setSisaDaging }: {
  formData: any, handleChange: any, resetForm: any, sisaDaging: number, setSisaDaging: React.Dispatch<React.SetStateAction<number>>
}) => {
  const [selectedVegetables, setSelectedVegetables] = useState<{ title: string }[]>([]);
  const [availableRicePackages, setAvailableRicePackages] = useState<PaketNasiItem[]>([]);
  const [minBox, setMinBox] = useState<number | null>(null);
  const [totalPrice, setTotalPrice] = useState<number>(0);
  const [pilihKambing, setPilihKambing] = useState<string>('');
  const [jumlahPotong, setJumlahPotong] = useState<number>(0);
  const [jumlahEkor, setJumlahEkor] = useState<number>(0);
  const [jumlahBox, setJumlahBox] = useState<string>(''); // ubah dari number ke string
  // const [pakaiJantan, setPakaiJantan] = useState<boolean>(false);
  const [jumlahBoxCatering, setJumlahBoxCatering] = useState<string>('');
  const [totalPriceCatering, setTotalPriceCatering] = useState<number>(0);


  const jumlahPotongTotal = jumlahPotong * jumlahEkor;

  const selectedPaket = paketKambing.find(p => p.title === formData.paket_katalog);
  const isRuby = selectedPaket?.title.toLowerCase().includes('ruby') ?? false;

  const selectedCatering = paketCatering.find(p => p.title === formData.paket_catering);
  const [jumlahBoxOptions, setJumlahBoxOptions] = useState<{ value: string; label: string }[]>([]);

  const isPaketBox = formData.paket_katalog?.trim() === 'Box Cetak' || formData.paket_katalog?.trim() === 'Box Sebar';
  const opsiKkjUntukDitampilkan = isPaketBox ? opsiKkjTerbatas : opsiKkjLengkap;

  const [isBoxOptionsReady, setIsBoxOptionsReady] = useState(false);

  const isDropdownPackage =
    formData.paket_katalog?.trim() === 'Sate A' ||
    formData.paket_katalog?.trim() === 'Sate B';
    // formData.paket_katalog?.trim() === 'Box Cetak' ||
    // formData.paket_katalog?.trim() === 'Box Sebar';

  const isBoxKatalog = formData.paket_katalog?.trim() === 'Box Cetak' || formData.paket_katalog?.trim() === 'Box Sebar';
  const isBoxKatalogB = formData.paket_katalog?.trim() === 'B Ultimate Cetak' || formData.paket_katalog?.trim() === 'B Ultimate Sebar' || formData.paket_katalog?.trim() === 'B Ruby Cetak' || formData.paket_katalog?.trim() === 'B Ruby Sebar';
  const sayurOptions = isBoxKatalog ? optionsBox : isBoxKatalogB ? optionsKatalogB : options;
  const masakanDagingOptions = isBoxKatalogB
    ? [
        { value: 'semur', label: 'Semur' },
        { value: 'bistik', label: 'Bistik (Best Seller)' },
      ]
    : [
        { value: 'semur', label: 'Semur' },
        { value: 'bistik', label: 'Bistik (Best Seller)' },
        { value: 'rendang', label: 'Rendang' },
      ];
  const minJumlahBox = selectedPaket?.minBox ?? 50;
  const isKatalogB = (selectedPaket?.title || '').trim().startsWith('B ');
  const shouldChargeKkj = isRuby || isKatalogB;
  const kkjDipilih = shouldChargeKkj ? kkjDenganBiayaTambahan.find(item => item.nama === formData.kkj) : undefined;
  const getKkjOptionLabel = (option: { value: string; label: string }) => {
    if (!shouldChargeKkj) {
      return option.label;
    }

    const biayaItem = kkjDenganBiayaTambahan.find(item => item.nama === option.value);
    if (!biayaItem || biayaItem.biaya <= 0) {
      return option.label;
    }

    return `${option.label} (+${biayaItem.biaya.toLocaleString('id-ID')}/box)`;
  };

  const prevPaketKatalog = useRef<string | undefined>(undefined);
  const isFirstRender = useRef(true);

  const isDisabled = !formData.paket_katalog;

  const paketKatalogFormControlRef = useRef<HTMLDivElement>(null);
  const paketKatalogInputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    const pilihanKkjMasihValid = opsiKkjUntukDitampilkan.some(opsi => opsi.value === formData.kkj);
    if (formData.kkj && !pilihanKkjMasihValid) {
      handleChange({ target: { name: 'kkj', value: '' } });
    }
  }, [formData.paket_katalog, formData.kkj, opsiKkjUntukDitampilkan, handleChange]);


  useEffect(() => {
    // Sinkronisasi 'pilih_kambing'
    setPilihKambing(formData.pilih_kambing || '');
  }, [formData.pilih_kambing]);

  useEffect(() => {
    const paket = formData.paket_katalog?.trim();
    if (paket === 'Sate A' || paket === 'Sate B' || paket === 'Box Cetak' || paket === 'Box Sebar') {
      if (pilihKambing !== '') {
        setPilihKambing('');
        handleChange({ target: { name: 'pilih_kambing', value: '' } });
      }
    }
    // Tidak perlu else, biarkan user memilih kambing jika bukan paket di atas
  }, [formData.paket_katalog]); // dependensi: paket_katalog


  useEffect(() => {

    // Sinkronisasi 'jumlah_ekor'
    const ekor = formData.jumlah_ekor ? parseInt(formData.jumlah_ekor as string, 10) : 0;

    setJumlahEkor(isNaN(ekor) ? 0 : ekor);
  }, [formData.jumlah_ekor]);

  useEffect(() => {
    // Sinkronisasi 'jumlahBox' (dari 'amount_rice' di formData)
    setJumlahBox(formData.amount_rice || '');
  }, [formData.amount_rice]);

  useEffect(() => {
    // Sinkronisasi 'selectedVegetables'
    const vegetables = formData.selectedVegetables;
    if (Array.isArray(vegetables)) {
      // Pastikan formatnya adalah array objek { title: string }
      const formattedVegetables = vegetables
        .map(veg => (typeof veg === 'string' ? { title: veg } : veg)) // Konversi string ke objek jika perlu
        .filter(veg => veg && typeof veg.title === 'string'); // Filter item yang valid
      setSelectedVegetables(formattedVegetables as { title: string }[]);
    } else {
      setSelectedVegetables([]); // Default ke array kosong jika tidak valid
    }
  }, [formData.selectedVegetables]);

  useEffect(() => {
    // Sinkronisasi 'jumlahBoxCatering' (dari 'amount_box_catering' di formData)
    setJumlahBoxCatering(formData.amount_box_catering || '');
  }, [formData.amount_box_catering]);

  useEffect(() => {
    // Sinkronisasi 'jumlahPotong' (dari 'jumlah_daging' di formData)
    // Asumsi jumlah_daging di formData disimpan sebagai string
    setJumlahPotong(formData.jumlah_daging ? parseInt(formData.jumlah_daging as string, 10) : 0);
  }, [formData.jumlah_daging]);


  useEffect(() => {
    resetForm();
  }, [formData.pilih_paket, formData.niat]);

  // GANTI useEffect lama Anda dengan yang ini

  useEffect(() => {
    if (isFirstRender.current) {
      // Lewati reset pada render pertama (mount)
      prevPaketKatalog.current = formData.paket_katalog;
      isFirstRender.current = false;
      return;
    }

    if (prevPaketKatalog.current !== formData.paket_katalog) {
      setJumlahBox('');
      handleChange({ target: { name: 'amount_rice', value: '' } });
      handleChange({ target: { name: 'masakan_daging', value: '' } });
      handleChange({ target: { name: 'kkj', value: '' } });

      prevPaketKatalog.current = formData.paket_katalog;
    }

    const selectedPackage = paketKambing.find((pkg) => pkg.title === formData.paket_katalog);

    setAvailableRicePackages(selectedPackage ? selectedPackage.paketNasi : []);
    setMinBox(selectedPackage ? selectedPackage.minBox : null);

    // --- PERBAIKAN LOGIKA DIMULAI DI SINI ---
    // if (selectedPackage) {
    //   // Hanya atur jumlah box minimal JIKA `amount_rice` belum diisi sama sekali.
    //   // Ini mencegah nilai yang sudah ada tertimpa saat navigasi kembali.
    //   if (!formData.amount_rice) {
    //     // Untuk paket Sate/Box, kita tidak ingin mengisi nilai minimal, biarkan kosong agar user memilih.
    //     const isDropdownPackage =
    //       selectedPackage.title.trim() === 'Sate A' ||
    //       selectedPackage.title.trim() === 'Sate B' ||
    //       selectedPackage.title.trim() === 'Box Cetak' ||
    //       selectedPackage.title.trim() === 'Box Sebar';

    //     if (!isDropdownPackage) {
    //       // Hanya set minBox untuk paket yang inputnya manual (bukan dropdown)
    //       handleChange({ target: { name: "amount_rice", value: String(selectedPackage.minBox) } });
    //     }
    //   }
    // } else {
    //   setAvailableRicePackages([]);
    //   setMinBox(null);
    //   // Jangan reset amount_rice di sini, karena bisa menghapus nilai saat paket belum dipilih
    // }
  }, [formData.paket_katalog, handleChange]); // Tambahkan handleChange ke dependensi
  useEffect(() => {
    const selectedPackage = paketKambing.find(pkg => pkg.title === formData.katalog);

    if (selectedPackage && formData.amount_rice) {
      const basePrice = selectedPackage.priceBox;
      const kebuliExtra = formData.package_rice && formData.package_rice.includes("Kebuli") ? selectedPackage.priceKebuli : 0;
      const total = (basePrice + kebuliExtra) * formData.amount_rice;

      setTotalPrice(total);
    } else {
      setTotalPrice(0);
    }
  }, [formData.paket_katalog, formData.package_rice, formData.amount_rice]);

  useEffect(() => {
    const selectedCatering = paketCatering.find(pkg => pkg.title === formData.paket_catering);
    const jumlahBoxCateringNumber = parseInt(jumlahBoxCatering || '0', 10);

    if (selectedCatering) {
      const basePrice = selectedCatering.priceBox;
      const total = basePrice * (jumlahBoxCateringNumber || 0);

      setTotalPriceCatering(total);
    } else {
      setTotalPriceCatering(0);
    }
  }, [formData.paket_catering, jumlahBoxCatering]);

  // useEffect(() => {
  //   // Jika jumlah box di bawah 80, pakaiJantan harus false
  //   if (parseInt(jumlahBox || '0', 10) < 80 && pakaiJantan) {
  //     setPakaiJantan(false);
  //     handleChange({
  //       target: {
  //         name: 'pakai_jantan',
  //         value: false,
  //       },
  //     });

  //     // Reset jumlah_jantan ke 0
  //     handleChange({
  //       target: {
  //         name: 'jumlah_jantan',
  //         value: 0,
  //       },
  //     });
  //   }
  // }, [jumlahBox, pakaiJantan, handleChange]);

  const handlePilihKambing = (event: ChangeEvent<HTMLInputElement>) => {
    setPilihKambing(event.target.value);
    handleChange({ target: { name: 'pilih_kambing', value: event.target.value } }); // Update formData

  };

  useEffect(() => {
    const paketKatalogTrimmed = formData.paket_katalog?.trim();
    const isSatePackage = paketKatalogTrimmed === 'Sate A' || paketKatalogTrimmed === 'Sate B';
    const currentAmountRice = formData.amount_rice;

    // Hanya jalankan jika ini paket sate, ada opsi yang tersedia, dan ada nilai untuk diperiksa
    if (isSatePackage && jumlahBoxOptions.length > 0 && currentAmountRice) {

      // Cek apakah nilai saat ini adalah angka (atau string angka) dan BUKAN string deskriptif
      const isInvalidNumberValue = String(currentAmountRice).match(/^\d+$/) && !String(currentAmountRice).includes('(');

      if (isInvalidNumberValue) {
        console.warn(`[PERBAIKAN OTOMATIS] Terdeteksi nilai amount_rice yang salah: "${currentAmountRice}". Mencari string yang benar...`);

        // Cari opsi string lengkap yang dimulai dengan angka yang salah tersebut
        const correctOption = jumlahBoxOptions.find(opt =>
          opt.value.startsWith(String(currentAmountRice) + ' ')
        );

        if (correctOption) {
          console.warn(`[PERBAIKAN OTOMATIS] Ditemukan: "${correctOption.value}". Memperbaiki state...`);
          // Panggil handleChange untuk "memperbaiki" nilai di state induk
          handleChange({
            target: {
              name: 'amount_rice',
              value: correctOption.value
            }
          });
        }
      }
    }
    // Jalankan efek ini setiap kali nilai amount_rice atau daftar opsi berubah
  }, [formData.amount_rice, jumlahBoxOptions, formData.paket_katalog, handleChange]);

  useEffect(() => {
    const paketKatalog = formData.paket_katalog?.trim(); // Hapus spasi tambahan
    if (paketKatalog === 'Sate A' || paketKatalog === 'Sate B') {
      console.log(`Paket katalog yang dipilih adalah: ${paketKatalog}`);
    } else {
      console.log(`Paket katalog yang dipilih bukan Sate A atau Sate B: ${paketKatalog}`);
    }
  }, [formData.paket_katalog]);
  useEffect(() => {
    console.log(`%c[useEffect] Mulai Membuat Opsi Jumlah Box (Sate)`, 'color: #fd7e14; font-weight: bold;');
    console.log('--- Menggunakan state lokal `jumlahEkor` saat ini:', jumlahEkor);

    const paketKatalog = formData.paket_katalog?.trim(); // Hapus spasi tambahan
    if (paketKatalog === 'Sate A' || paketKatalog === 'Sate B') {
      setIsBoxOptionsReady(false);
      const options: { value: string; label: string }[] = [];

      if (paketKatalog === 'Sate A') {
        if (jumlahEkor === 1) {
          options.push(
            { value: '50 (sisa sate 50 tusuk)', label: '50 (sisa sate 50 tusuk)' },
            { value: '85 (tanpa sisa)', label: '85 (tanpa sisa)' },
            { value: '100 (tanpa sisa)', label: '100 (tanpa sisa)' },
            { value: '125 (sisa sate 25 tusuk)', label: '125 (sisa sate 25 tusuk)' }
          );
        } else if (jumlahEkor === 2) {
          options.push(
            { value: '100 (sisa sate 100 tusuk)', label: '100 (sisa sate 100 tusuk)' },
            { value: '125 (sisa sate 25 tusuk)', label: '125 (sisa sate 25 tusuk)' },
            { value: '150 (sisa sate 50 tusuk)', label: '150 (sisa sate 50 tusuk)' },
            { value: '200 (tanpa sisa sate)', label: '200 (tanpa sisa sate)' }
          );
        }
      } else if (paketKatalog === 'Sate B') {
        if (jumlahEkor === 1) {
          options.push(
            { value: '50 (sisa sate 50 tusuk)', label: '50 (sisa sate 50 tusuk)' },
            { value: '85 (sisa sate 5 tusuk)', label: '85 (sisa sate 5 tusuk)' },
            { value: '100 (sisa sate 15 tusuk)', label: '100 (sisa sate 15 tusuk)' },
            { value: '125 (sisa sate 25 tusuk)', label: '125 (sisa sate 25 tusuk)' }
          );
        } else if (jumlahEkor === 2) {
          options.push(
            { value: '100 (sisa sate 100 tusuk)', label: '100 (sisa sate 100 tusuk)' },
            { value: '125 (sisa sate 25 tusuk)', label: '125 (sisa sate 25 tusuk)' },
            { value: '150 (sisa sate 50 tusuk)', label: '150 (sisa sate 50 tusuk)' },
            { value: '200 (tanpa sisa sate)', label: '200 (tanpa sisa sate)' }
          );
        }
      } 
      // else if (paketKatalog === 'Box Cetak' || paketKatalog === 'Box Sebar') {
      //   if (jumlahEkor === 1) {
      //     options.push(
      //       { value: '50 Box', label: '50 Box' },
      //       { value: '80 Box', label: '80 Box' },
      //       { value: '100 Box', label: '100 Box' },
      //       { value: '125 Box', label: '125 Box' },
      //       { value: '150 Box', label: '150 Box' },
      //       { value: '200 Box', label: '200 Box' },

      //     );
      //   } else if (jumlahEkor === 2) {
      //     options.push(
      //       { value: '50 Box', label: '50 Box' },
      //       { value: '80 Box', label: '80 Box' },
      //       { value: '100 Box', label: '100 Box' },
      //       { value: '125 Box', label: '125 Box' },
      //       { value: '150 Box', label: '150 Box' },
      //       { value: '200 Box', label: '200 Box' },
      //     );
      //   }
      // }
      console.log('--- Opsi yang berhasil dibuat:', options.map(o => o.value));

      setJumlahBoxOptions(options);
      setIsBoxOptionsReady(true);

      const currentBoxValue = formData.amount_rice;


      // Logika tambahan untuk mereset pilihan jika tidak valid lagi
      console.log('--- Memeriksa kecocokan. Nilai tersimpan:', `"${currentBoxValue}"`);
      if (currentBoxValue && options.length > 0 && !options.find(opt => opt.value === currentBoxValue)) {
        console.warn('--- PERINGATAN: Nilai tersimpan TIDAK DITEMUKAN di dalam opsi!');
      } else if (currentBoxValue && options.find(opt => opt.value === currentBoxValue)) {
        console.log('--- INFO: Nilai tersimpan COCOK dengan opsi.');
      }

    } else {
      setJumlahBoxOptions([]);
    }
    console.log(`%c[useEffect] Selesai Membuat Opsi`, 'color: #fd7e14; font-weight: bold;');


  }, [formData.paket_katalog, jumlahEkor, formData.amount_rice, handleChange]);


  const handleJumlahEkorChange = (event: ChangeEvent<HTMLInputElement>) => {
    const value = parseInt(event.target.value, 10);
    if (value >= 1 && value <= 2) {
      setJumlahEkor(value);
      handleChange({ target: { name: 'jumlah_ekor', value: value.toString() } });
    }
  };

  const handleJumlahBoxChange = (event: ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setJumlahBox(value);
    handleChange({ target: { name: 'amount_rice', value } });
  };

  const handleJumlahPotongChange = (event: ChangeEvent<HTMLInputElement>) => {
    const value = Number(event.target.value);
    setJumlahPotong(value);
    handleChange({ target: { name: 'jumlah_daging', value } }); // Update formData
  };


  // const handleJumlahBoxCateringChange = (event: ChangeEvent<HTMLInputElement>) => {
  //     const value = parseInt(event.target.value, 10);
  //       setJumlahBoxCatering(value);
  //       handleChange({ target: { name: 'amount_box_catering', value } }); // Update formData
  //   };


  //non kambing
  useEffect(() => {
    const selectedCatering = paketCatering.find(p => p.title === formData.paket_catering);
    const jumlahBoxCateringNumber = parseInt(jumlahBoxCatering || '0', 10);

    if (!selectedCatering) return;
    const hargaBoxCatering = selectedCatering.priceBox * jumlahBoxCateringNumber;
    setTotalPrice(hargaBoxCatering);

  }, [
    formData.paket_catering,
    jumlahBoxCatering,
  ]);
  //kambing
  useEffect(() => {
    const selectedPaket = paketKambing.find(p => p.title === formData.paket_katalog);
    const potongan = dataKambing[pilihKambing];
    const selectedPotong = potongan?.find(p => p.jumlahDaging === Number(jumlahPotong));

    if (!selectedPaket || !selectedPotong || !jumlahEkor) return;

    // Total potongan daging & harga berdasarkan jumlah ekor
    const totalDaging = selectedPotong.jumlahDaging * jumlahEkor;
    const totalHargaKambing = selectedPotong.harga * jumlahEkor;
    const jumlahBoxNumber = parseInt(jumlahBox || '0', 10);

    const isKebuli = formData.package_rice?.toLowerCase().includes('kebuli');
    const kebuliExtra = isKebuli ? selectedPaket.priceKebuli * jumlahBoxNumber : 0;
    // const tambahanJantan = pakaiJantan ? 900000 * (formData.jumlah_jantan || jumlahEkor) : 0;

    // Cari apakah menu KKJ yang dipilih termasuk yang dikenakan biaya tambahan
    const isRuby = selectedPaket.title.toLowerCase().includes('ruby');
    const isKatalogB = selectedPaket.title.trim().startsWith('B ');
    const shouldChargeKkj = isRuby || isKatalogB;
    const kkjDipilih = shouldChargeKkj ? kkjDenganBiayaTambahan.find(item => item.nama === formData.kkj) : undefined;
    const tambahanKKJ = kkjDipilih ? kkjDipilih.biaya * jumlahBoxNumber : 0;

    const jumlahKulitDimasak = formData.kulit === 'dimasak' ? (formData.jumlah_kulit_dimasak || 0) : 0;
    const biayaKulit = jumlahKulitDimasak * 80000;


    const hargaBox = selectedPaket.priceBox * jumlahBoxNumber + kebuliExtra + tambahanKKJ;
    // const total = hargaBox + totalHargaKambing + tambahanJantan + biayaKulit;
    const total = hargaBox + totalHargaKambing + biayaKulit;

    setTotalPrice(total);

    const totalPotongDigunakan = jumlahBoxNumber;
    const sisa = totalDaging - totalPotongDigunakan;
    setSisaDaging(sisa >= 0 ? sisa : 0);
    handleChange({
      target: {
        name: 'sisa_daging',
        value: sisa >= 0 ? sisa : 0,
      },
    });
  }, [
    formData.paket_katalog,
    formData.package_rice,
    formData.kkj,
    formData.jumlah_kulit_dimasak,
    formData.kulit,
    jumlahBox,
    jumlahPotong,
    pilihKambing,
    jumlahEkor,
    // pakaiJantan,
    formData.jumlah_jantan
  ]);

  // Modifikasi useEffect yang mengatur jumlah_kulit_dimasak
  useEffect(() => {
    if (formData.kulit === 'dimasak') {
      const currentJumlahKulitDimasakStr = formData.jumlah_kulit_dimasak as string;
      const currentJumlahKulitDimasakNum = parseInt(currentJumlahKulitDimasakStr, 10);
      const ekorJumlahLokal = jumlahEkor; // Gunakan state lokal jumlahEkor yang sudah disinkronisasi

      if (ekorJumlahLokal > 0) {
        // Jika jumlah ekor valid, sesuaikan jumlah kulit
        if (isNaN(currentJumlahKulitDimasakNum) || currentJumlahKulitDimasakNum <= 0 || currentJumlahKulitDimasakNum > ekorJumlahLokal) {
          handleChange({ target: { name: 'jumlah_kulit_dimasak', value: ekorJumlahLokal.toString() } });
        }
      } else {
        // Jika jumlahEkor 0 (belum dipilih atau memang 0) tapi kulit mau dimasak
        if (isNaN(currentJumlahKulitDimasakNum) || currentJumlahKulitDimasakNum <= 0) {
          // Default ke 1 jika jumlahEkor 0 tapi memilih masak kulit
          handleChange({ target: { name: 'jumlah_kulit_dimasak', value: '1' } });
        }
        // Jika currentJumlahKulitDimasakNum > 0 tapi ekorJumlahLokal 0, biarkan (misal: user input 1 kulit, belum pilih ekor)
      }
    } else { // Jika kulit tidak dimasak
      if (formData.jumlah_kulit_dimasak || formData.menu_kulit) { // Reset jika ada nilai sebelumnya
        handleChange({ target: { name: 'jumlah_kulit_dimasak', value: '' } });
        handleChange({ target: { name: 'menu_kulit', value: '' } });
      }
    }
  }, [jumlahEkor, formData.kulit, formData.jumlah_kulit_dimasak, handleChange]); // Tambahkan handleChange

  // Scroll/focus to Paket Katalog when entering step 2 or when paket_katalog becomes empty
  useEffect(() => {
    if (paketKatalogFormControlRef.current) {
      paketKatalogFormControlRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    if (paketKatalogInputRef.current) {
      paketKatalogInputRef.current.focus();
    }
  }, [formData.paket_katalog]);


  return (
    <Stack spacing={2} sx={{ width: '100%' }}>
      {formData.pilih_paket === 'nonkambing' && (
        <>
          <FormControl fullWidth>
            <FormLabel htmlFor="paket_catering" sx={{ textAlign: 'left' }}>
              Paket Catering
            </FormLabel>
            <TextField
              select
              value={formData.paket_catering}
              onChange={handleChange}
              id="paket_catering"
              name="paket_catering"
              placeholder="Pilih Paket Catering"
              autoFocus
              required
              fullWidth
              variant="outlined"
            >
              <MenuItem value="" disabled>
                Pilih Paket Catering
              </MenuItem>
              {paketCatering.map((paket, index) => (
                <MenuItem key={index} value={paket.title}>
                  {paket.title}
                </MenuItem>
              ))}
            </TextField>
          </FormControl>
          <Box>
            {formData.paket_catering && (
              paketCatering.find((paket) => paket.title === formData.paket_catering)?.imgPath && (
                <Box
                  component="img"
                  sx={{
                    width: '100%',
                    maxWidth: { xs: '100%', md: '300px' },
                    height: 'auto',
                    objectFit: 'contain', // Changed from 'cover' to 'contain'
                    borderRadius: 2
                  }}
                  src={paketCatering.find((paket) => paket.title === formData.paket_catering)?.imgPath}
                  alt={formData.paket_catering}
                />
              )
            )}
          </Box>
          <FormControl fullWidth sx={{ textAlign: 'left' }}>
            <FormLabel htmlFor="amount_box_catering" sx={{ textAlign: "left" }}>
              Jumlah Box Nasi {paketCatering.find((paket) => paket.title === formData.paket_catering)?.minBox ? `(Minimal ${paketCatering.find((paket) => paket.title === formData.paket_catering)?.minBox} Box)` : ""}
            </FormLabel>
            <TextField
              type="text"
              value={jumlahBoxCatering}
              onChange={(e) => {
                const value = e.target.value;

                // Cek apakah hanya angka
                if (/^\d*$/.test(value)) {
                  const numericValue = parseInt(value || "0", 10);

                  // Izinkan kosong saat mengetik
                  if (value === "") {
                    setJumlahBoxCatering("");
                    handleChange({ target: { name: "amount_box_catering", value: "" } }); // Update formData

                  }
                  // Izinkan hanya angka antara 40 dan jumlahPotongTotal
                  else if (numericValue <= 1000) {
                    setJumlahBoxCatering(value);
                    handleChange({ target: { name: "amount_box_catering", value } }); // Update formData

                  }
                  // Kalau diluar range, jangan update state => otomatis nge-blok
                }
              }}
              name="amount_box_catering"
              variant="outlined"
              fullWidth
              required
              error={
                jumlahBoxCatering !== "" && parseInt(jumlahBoxCatering, 10) < 50
              }
              helperText={
                jumlahBoxCatering !== "" && parseInt(jumlahBoxCatering, 10) < 50
                  ? "Minimal 50 box"
                  : ""
              }

            />
          </FormControl>

          <Box sx={{ mt: 3, p: 2, border: '1px solid #ddd', borderRadius: 2 }}>
            <Typography variant="h6">Rincian Biaya</Typography>
            <Typography>Jumlah Box: {jumlahBoxCatering}</Typography>
            <Typography sx={{ mt: 1, fontWeight: 'bold' }}>
              Total Harga: Rp {totalPriceCatering.toLocaleString()}
            </Typography>
            <Alert severity="info" sx={{ mt: 1 }}>
              <strong>Perkiraan Rincian Biaya</strong> belum termasuk biaya pengiriman, dan request pelanggan.
            </Alert>

          </Box>

        </>
      )}
      {(formData.niat === 'aqiqah' || formData.pilih_paket === 'kambing') && (
        <>
          <FormControl fullWidth sx={{ textAlign: 'left' }} ref={paketKatalogFormControlRef}>
            <FormLabel htmlFor="paket_katalog" sx={{ textAlign: 'left' }}>
              Paket Katalog
            </FormLabel>
            <TextField
              select
              value={formData.paket_katalog}
              onChange={handleChange}
              id="paket_katalog"
              name="paket_katalog"
              placeholder="Pilih Paket Katalog"
              autoFocus
              required
              fullWidth
              variant="outlined"
              inputRef={paketKatalogInputRef}
            >
              <MenuItem value="" disabled>
                Pilih Paket Katalog
              </MenuItem>
              {paketKambing.map((paket, index) => (
                <MenuItem key={index} value={paket.title}>
                  {paket.title}
                </MenuItem>
              ))}
            </TextField>
          </FormControl>

          <FormControl fullWidth sx={{ textAlign: "left" }}>
            <FormLabel htmlFor="package_rice" sx={{ textAlign: "left" }}>
              Nama Paket Nasi
            </FormLabel>
            <TextField
              select
              value={formData.package_rice}
              onChange={handleChange}
              id="package_rice"
              name="package_rice"
              fullWidth
              variant="outlined"
              disabled={isDisabled}
              placeholder={isDisabled ? "Pilih Paket Katalog terlebih dahulu" : "Pilih Paket Nasi"}
            >
              <MenuItem value="">{isDisabled ? "Pilih Paket Katalog terlebih dahulu" : "Pilih Paket Nasi"}</MenuItem>
              {availableRicePackages.map((rice, index) => (
                <MenuItem key={index} value={rice.title}>
                  {rice.title}
                </MenuItem>
              ))}
            </TextField>
          </FormControl>


          <Box>
            {availableRicePackages.find((r) => r.title === formData.package_rice)?.imgPath && (
              <Box
                component="img"
                sx={{
                  width: '100%',
                  maxWidth: { xs: '100%', md: '300px' },
                  height: 'auto',
                  objectFit: 'cover',
                  borderRadius: 2,
                  mt: 2
                }}
                src={availableRicePackages.find((r) => r.title === formData.package_rice)?.imgPath}
                alt={formData.package_rice}
              />
            )}

          </Box>


          {isDropdownPackage ? (
            <>
              <FormControl fullWidth sx={{ textAlign: 'left' }}>
                <FormLabel htmlFor="jumlah_ekor" sx={{ textAlign: 'left' }}>
                  Jumlah Ekor (maks. 2)
                </FormLabel>
                <TextField
                  select
                  value={jumlahEkor}
                  onChange={handleJumlahEkorChange}
                  name="jumlah_ekor"
                  variant="outlined"
                  fullWidth
                  required
                >
                  <MenuItem value="" disabled>
                    Pilih Jumlah Ekor
                  </MenuItem>
                  <MenuItem value={1}>1</MenuItem>
                  <MenuItem value={2}>2</MenuItem>
                </TextField>
              </FormControl>

              {jumlahEkor > 0 && isBoxOptionsReady && (
                <FormControl fullWidth sx={{ textAlign: 'left' }}>
                  <FormLabel htmlFor="jumlah_box" sx={{ textAlign: 'left' }}>
                    Jumlah Box
                  </FormLabel>
                  <TextField
                    select
                    value={jumlahBox}
                    onChange={handleJumlahBoxChange}
                    name="amount_rice"
                    variant="outlined"
                    fullWidth
                    required
                  >
                    <MenuItem value="" disabled>
                      Pilih Jumlah Box
                    </MenuItem>
                    {jumlahBoxOptions.map((option, index) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </FormControl>
              )}
              {!(formData.paket_katalog?.trim() === 'Sate A' || formData.paket_katalog?.trim() === 'Sate B') && (
                <FormControl fullWidth sx={{ textAlign: 'left' }}>
                  <FormLabel htmlFor="masakan_daging" sx={{ textAlign: 'left' }}>
                    Masakan Daging
                  </FormLabel>
                  <TextField
                    select
                    value={formData.masakan_daging}
                    onChange={handleChange}
                    id="masakan_daging"
                    name="masakan_daging"
                    placeholder="Pilih Masakan Daging"
                    autoFocus
                    required
                    fullWidth
                    variant="outlined"
                  >
                  <MenuItem value="" disabled>Pilih Masakan Daging</MenuItem>
                  {masakanDagingOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                  </TextField>
                </FormControl>
              )}
            </>
          ) : (
            <>
              <FormControl fullWidth sx={{ textAlign: 'left' }}>
                <FormLabel htmlFor="pilih_kambing" sx={{ textAlign: 'left' }}>Pilih Kambing</FormLabel>
                <TextField
                  select
                  value={pilihKambing}
                  onChange={handlePilihKambing}
                  name="pilih_kambing"
                  variant="outlined"
                  fullWidth
                  required
                  disabled={isDisabled}
                  placeholder={isDisabled ? "Pilih Paket Katalog terlebih dahulu" : "Pilih Kambing"}
                >
                  <MenuItem value="" disabled>
                    {isDisabled ? "Pilih Paket Katalog terlebih dahulu" : "Pilih Jenis Kambing"}
                  </MenuItem>
                  <MenuItem value="Jawa">Kambing Jawa (+75.000/ekor)</MenuItem>
                  <MenuItem value="Domba">Kambing Domba</MenuItem>
                </TextField>
                <Alert severity="info" sx={{ mt: 1 }}>
                  <strong>Jenis yang digunakan betina.</strong> Jika request jantan chat Admin.
                  {pilihKambing === 'Jawa' && (
                    <><br /><strong>Pilih Kambing Jawa (+75.000/ekor)</strong></>
                  )}
                </Alert>
              </FormControl>

              {pilihKambing && (
                <>
                  <FormControl fullWidth sx={{ textAlign: 'left' }}>
                    <FormLabel htmlFor="jumlah_ekor" sx={{ textAlign: 'left' }}>Jumlah Ekor (maks. 2)</FormLabel>
                    <TextField
                      select
                      value={jumlahEkor}
                      onChange={handleJumlahEkorChange}
                      name="jumlah_ekor"
                      variant="outlined"
                      fullWidth
                      required
                    >
                      <MenuItem value="" disabled>Pilih Jumlah Ekor</MenuItem>
                      <MenuItem value={1} selected>1</MenuItem>
                      <MenuItem value={2}>2</MenuItem>
                    </TextField>
                  </FormControl>

                  <FormControl fullWidth>
                    <FormLabel sx={{ textAlign: 'left' }}>
                      Jumlah Box (min. {minJumlahBox})
                    </FormLabel>
                    <TextField
                      type="text"
                      value={jumlahBox}
                      onChange={(e) => {
                        const value = e.target.value;

                        // Cek apakah hanya angka
                        if (/^\d*$/.test(value)) {
                          const numericValue = parseInt(value || "0", 10);

                          // Izinkan kosong saat mengetik
                          if (value === "") {
                            setJumlahBox("");
                            handleChange({ target: { name: "amount_rice", value: "" } }); // Update formData

                          }
                          // Izinkan angka valid untuk jumlah box
                          else if (numericValue) {
                            setJumlahBox(value);
                            handleChange({ target: { name: "amount_rice", value } }); // Update formData

                          }
                          // Kalau diluar range, jangan update state => otomatis nge-blok
                        }
                      }}
                      name="amount_rice"
                      variant="outlined"
                      fullWidth
                      required
                      error={
                        jumlahBox !== "" && parseInt(jumlahBox, 10) < minJumlahBox
                      }
                      helperText={
                        jumlahBox !== "" && parseInt(jumlahBox, 10) < minJumlahBox
                          ? `Minimal ${minJumlahBox} box`
                          : ""
                      }

                    />
                  </FormControl>

                </>
              )}

              <FormControl fullWidth sx={{ textAlign: 'left' }}>
                <FormLabel htmlFor="masakan_daging" sx={{ textAlign: 'left' }}>
                  Masakan Daging
                </FormLabel>
                <TextField
                  select
                  value={formData.masakan_daging}
                  onChange={handleChange}
                  id="masakan_daging"
                  name="masakan_daging"
                  placeholder={isDisabled ? "Pilih Paket Katalog terlebih dahulu" : "Pilih Masakan Daging"}
                  autoFocus
                  required
                  fullWidth
                  variant="outlined"
                  disabled={isDisabled}
                >
                  <MenuItem value="" disabled>{isDisabled ? "Pilih Paket Katalog terlebih dahulu" : "Pilih Masakan Daging"}</MenuItem>
                  {masakanDagingOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
              </FormControl>
            </>
          )}

          <FormControl fullWidth sx={{ textAlign: 'left' }}>
            <FormLabel htmlFor="kkj" sx={{ textAlign: 'left' }}>
              Masakan Kepala Kaki Jeroan (KKJ)
            </FormLabel>
            <TextField
              select
              value={formData.kkj}
              onChange={handleChange}
              id="kkj"
              name="kkj"
              placeholder={isDisabled ? "Pilih Paket Katalog terlebih dahulu" : "Pilih Masakan KKJ"}
              autoFocus
              required
              fullWidth
              variant="outlined"
              disabled={isDisabled}
            >
              <MenuItem value="" disabled>{isDisabled ? "Pilih Paket Katalog terlebih dahulu" : "Pilih Masakan KKJ"}</MenuItem>
              {opsiKkjUntukDitampilkan.map((opsi) => (
                <MenuItem key={opsi.value} value={opsi.value}>
                  {getKkjOptionLabel(opsi)}
                </MenuItem>
              ))}

            </TextField>
            {isKatalogB && kkjDipilih && (
              <Alert severity="info" sx={{ mt: 1 }}>
                Menu <strong>{formData.kkj}</strong> dikenakan biaya tambahan Rp{kkjDipilih.biaya.toLocaleString('id-ID')} per box pada paket Katalog B.
              </Alert>
            )}
            {isRuby && kkjDipilih && (
              <Alert severity="info" sx={{ mt: 1 }}>
                Menu <strong>{formData.kkj}</strong> dikenakan biaya tambahan Rp{kkjDipilih.biaya.toLocaleString('id-ID')} per box pada paket Ruby.
              </Alert>
            )}
          </FormControl>


          <FormControl fullWidth>
            <FormLabel sx={{ textAlign: 'left' }}>Pilihan Sayur</FormLabel>

            {(() => {
              const selectedPaket = paketKambing.find(p => p.title === formData.paket_katalog);
              const maxSayur = selectedPaket ? selectedPaket.sayur : 0;
              const isDisabled = !formData.paket_katalog; // Jika belum memilih paket, maka disable

              return (
                <Autocomplete
                  multiple
                  limitTags={2}
                  id="selectedVegetables"
                  options={sayurOptions}
                  getOptionLabel={(option) => option.title}
                  value={selectedVegetables}
                  onChange={(_, newValue) => {
                    if (Array.isArray(newValue) && newValue.length <= maxSayur) {
                      setSelectedVegetables(newValue);
                      handleChange({ target: { name: 'selectedVegetables', value: newValue.map(item => ({ title: item.title })) } });
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder={isDisabled ? "Pilih Paket Katalog terlebih dahulu" : `Maksimal ${maxSayur} sayur`}
                      fullWidth
                    />
                  )}
                  sx={{ width: '100%' }}
                  disabled={isDisabled} // Disable jika paket belum dipilih
                />
              );
            })()}
          </FormControl>


          <FormControl fullWidth sx={{ textAlign: 'left' }}>
            <FormLabel htmlFor="kulit" sx={{ textAlign: 'left' }}>
              Kulit
            </FormLabel>
            <TextField
              select
              value={formData.kulit}
              onChange={handleChange}
              id="kulit"
              name="kulit"
              placeholder={isDisabled ? "Pilih Paket Katalog terlebih dahulu" : "Pilih Kulit"}
              autoFocus
              required
              fullWidth
              variant="outlined"
              disabled={isDisabled}
            >
              <MenuItem value="" disabled>{isDisabled ? "Pilih Paket Katalog terlebih dahulu" : "Pilih Kulit"}</MenuItem>
              <MenuItem value="dimasak">Di masak</MenuItem>
              <MenuItem value="disumbangkan">Di sumbangkan</MenuItem>
            </TextField>
          </FormControl>

          {formData.kulit === 'dimasak' && (
            <>
              <Alert severity="info">
                Kulit di wadah terpisah, tidak masuk box. Per kulit dimasak akan dikenakan biaya Rp80.000
              </Alert>

              {/* Input jumlah kulit yang akan dimasak */}
              <FormControl fullWidth sx={{ textAlign: 'left' }}>
                <FormLabel htmlFor="jumlah_kulit_dimasak">Jumlah Kulit Dimasak</FormLabel>
                <TextField
                  select
                  value={formData.jumlah_kulit_dimasak || 1}
                  onChange={handleChange}
                  id="jumlah_kulit_dimasak"
                  name="jumlah_kulit_dimasak"
                  required
                >
                  {Array.from({ length: jumlahEkor }, (_, i) => (
                    <MenuItem key={i + 1} value={i + 1}>
                      {i + 1}
                    </MenuItem>
                  ))}
                </TextField>
              </FormControl>

              <Alert severity="info">
                Sisa kulit akan dianggap disumbangkan.
              </Alert>

              {/* Menu kulit (tongseng/cabe ijo) */}
              <FormControl fullWidth sx={{ textAlign: 'left' }}>
                <FormLabel htmlFor="menu_kulit">Menu Kulit</FormLabel>
                <TextField
                  select
                  value={formData.menu_kulit}
                  onChange={handleChange}
                  id="menu_kulit"
                  name="menu_kulit"
                  required
                >
                  <MenuItem value="tongseng">Tongseng</MenuItem>
                  <MenuItem value="cabe ijo">Cabe Ijo</MenuItem>
                </TextField>
              </FormControl>
            </>
          )}

        </>
      )}
    </Stack>
  );
};

export default Step2Form;
export { paketKambing };
